import { render, staticRenderFns } from "./IncomeUploadPage.vue?vue&type=template&id=0fe4c7e2&scoped=true"
import script from "./IncomeUploadPage.vue?vue&type=script&lang=ts"
export * from "./IncomeUploadPage.vue?vue&type=script&lang=ts"
import style0 from "./IncomeUploadPage.vue?vue&type=style&index=0&id=0fe4c7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4c7e2",
  null
  
)

export default component.exports